import { Client } from '@sr-sdks/api-sdk-axios';
import { WorkspaceTask } from '../../types/taskTypes';

export type ClientsMap = Map<string, Client>;

/** Under `details`: the task handlers store the MSR2 event payload there whole. */
export const getTaskClientId = (task: WorkspaceTask) =>
  task.details?.clientId ?? undefined;

/**
 * Key of a competing claim's other claimant as an agency option keys it:
 * `otherWorkspaceId.otherClientId`, with an empty client part for none.
 */
export const getOtherClaimantKey = (task: WorkspaceTask) => {
  const { otherClientId, otherWorkspaceId } = task.details ?? {};

  if (!otherWorkspaceId) return undefined;

  return `${otherWorkspaceId}.${otherClientId ?? ''}`;
};

/**
 * A competing claim's other claimant from names keyed as the filter options key
 * them. A non-agent claimant is keyed by workspace alone, whatever its otherClientId.
 */
export const getOtherClaimantName = (
  task: WorkspaceTask,
  namesByKey: Map<string, string>,
) => {
  const key = getOtherClaimantKey(task);
  const otherWorkspaceId = task.details?.otherWorkspaceId;

  return key && otherWorkspaceId
    ? (namesByKey.get(key) ?? namesByKey.get(otherWorkspaceId))
    : undefined;
};

export const extractUniqueClientIds = (tasks: WorkspaceTask[]) => {
  const clientIds = tasks
    .map(getTaskClientId)
    .filter((id): id is string => Boolean(id));

  return [...new Set(clientIds)];
};

/** Map of client id -> client for O(1) name lookups. */
export const createClientsMap = (clients?: Client[]): ClientsMap => {
  if (!clients) return new Map();

  return new Map(clients.map((client) => [client._id, client]));
};
